import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import plansFields from '../../fields/plansFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].label
 * @param {string} responseData.items[].parentSubscriptionPlan.label
 * @param {string} responseData.items[].productCode
 * @param {string} responseData.items[].createdAt
 * @param {string} responseData.items[].updatedAt
 * @param {number} responseData.totalResults
 * @param {boolean} responseData.shouldBlockNewPOS
 * @returns Mapped data object
 */
function mapResponseData({ items, shouldBlockNewPOS, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [plansFields.UUID.key]: item[plansFields.UUID.key],
        [plansFields.PARENT_SUBSCRIPTION_PLAN.key]: {
            [plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL.key]:
                getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL))
        },
        [plansFields.LABEL.key]: item[plansFields.LABEL.key],
        [plansFields.SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS.key]: item[plansFields.SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS.key],
        [plansFields.PRODUCT_CODE.key]: item[plansFields.PRODUCT_CODE.key],
        [plansFields.CREATED_AT.key]: item[plansFields.CREATED_AT.key],
        [plansFields.UPDATED_AT.key]: item[plansFields.UPDATED_AT.key]
    }));

    data.items = mappedItems;
    data.shouldBlockNewPOS = shouldBlockNewPOS;
    data.totalResults = totalResults;
    return data;
}

const queryGetPlans = ({ query, organizationId }, enabled) => {
    return {
        queryKey: [PLANS.COLLECTION.queryKey, query, organizationId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(PLANS.COLLECTION.url, { organizationId: organizationId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPlans;